import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App.js";
import Registration from "../pages/Registration/Registration";
import Landing from "../pages/Main/Landing";
import TermsAndConditions from "../pages/Registration/Terms";
import HrEvent from "../pages/HrEvent/HrEvent";
import OldLandingFoqus from "../pages/OldLandingFoqus/OldLandingFoqus";
import Presentation from "../pages/Presentation/Presentation";
import DownloadPDF from "../pages/Presentation/Presentation";
import LandingFoqus from "../pages/LandingFoqus/LandingFoqus";
import Onboarding from "../pages/Onboarding/Onboarding";
import ShishkaGuestLogin from "../pages/ShishkaGuestLogin/ShishkaGuestLogin";
import GalereyaOnboarding from "../pages/GalereyaOnboarding/GalereyaOnboarding";
import FaceRegistration from "../pages/FaceRegistration/FaceRegistration";
import GalereyaOnboardingFaceRec from "../pages/GalereyaOnboarding/GalereyaOnboardingFaceRec";
import StudentOnboardingFaceRec from "../pages/StudentOnboarding/StudentOnboardingFaceRec";
import UserLoyalty from "../pages/UserLoyalty/userLoyalty.jsx";
import Register from "../pages/UserLoyalty/pages/Register.jsx";
import Auth from "../pages/UserLoyalty/pages/Auth.jsx";
import Reservation from "../pages/UserLoyalty/pages/Reservation.jsx";
import Menu from "../pages/UserLoyalty/pages/Menu.jsx";
import UserReservations from "../pages/UserLoyalty/pages/UserReservations.jsx";
import SurveyComp from "../pages/UserSurvery/pages/Survey.jsx";
import UserSurvery from "../pages/UserSurvery/userSurvery.jsx";
import SurveryRegister from "../pages/UserSurvery/pages/Register.jsx";
import Main from "../pages/UserLoyalty/pages/Main.jsx";
const landingRoutes = ["/", "/blog", "/blog/:id", "/about-us"];
const allowedPlaceIds = ["shka17c8h3"]; // ✅ List of valid place_ids

const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      ...landingRoutes.map((item) => {
        return {
          path: item,
          element: <LandingFoqus />,
        };
      }),
      { path: "/main", element: <Landing /> },
      { path: "/creatti", element: <Registration /> },
      { path: "/terms", element: <TermsAndConditions /> },
      { path: "/hr-event", element: <HrEvent /> },
      // { path: '/landing', element: <OldLandingFoqus />},
      { path: "/onboarding", element: <Onboarding /> },
      { path: "/landing", element: <OldLandingFoqus /> },
      { path: "/presentation", element: <DownloadPDF /> },
      { path: "/hr-tech", element: <Landing /> },
      // ✅ Correct Dynamic Place ID Route
      {
        path: "/:placeId",
        element: <ShishkaGuestLogin />,
      },
      {
        path: "/glra12a4a6",
        element: <GalereyaOnboarding />,
      },
      {
        path: "/face-registration-test",
        element: <FaceRegistration />,
      },
      {
        path: "/galereya/glra12a4a6",
        element: <GalereyaOnboardingFaceRec />,
      },
      {
        path: "/onboarding/zasa05e1p1",
        element: <StudentOnboardingFaceRec />,
      },
      {
        path: "/userLoyalty",
        element: <UserLoyalty />, // Здесь будет <Outlet />
        children: [
          {
            path: "auth",
            element: <Auth />,
          },
          {
            path: "registration",
            element: <Register />,
          },
          {
            path: "main",
            element: <Main />,
          },
          {
            path: "reservation",
            element: <Reservation />,
          },
          {
            path: "menu",
            element: <Menu />,
          },
          {
            path: "userReservations",
            element: <UserReservations />,
          },
        ],
      },
      {
        path: "/happyCitizen",
        element: <UserSurvery />,
        children: [
          { path: "registration", element: <SurveryRegister /> },
          { path: "survey", element: <SurveyComp /> },
        ],
      },
    ],
  },
]);

export default routes;
